// extracted by mini-css-extract-plugin
export var background = "hero-module--background--qJgwr";
export var heroImage = "hero-module--heroImage--XSFYe";
export var projectInfo = "hero-module--projectInfo--ixLUi";
export var actions = "hero-module--actions--MpHss";
export var projectInfoSocialLinks = "hero-module--projectInfoSocialLinks--BM-3V";
export var projectInfoDescription = "hero-module--projectInfoDescription--7JW4x";
export var projectInfoHeader = "hero-module--projectInfoHeader--293wi";
export var heroMouseScrollWheel = "hero-module--heroMouseScrollWheel--rHyhy";